import './Help.css';
import { Box, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import useDeviceMedia from '../hooks/useDeviceMedia';
import { useRootStore } from '../hooks/useRootStore';

export default function Help() {
    const { api } = useRootStore();
    //const [html, setHtml] = useState('');
    const [asideTop, setAsideTop] = useState(0);
    const [appStateHeight, setAppStateHeight] = useState(0);
    const { isMobilePortrait } = useDeviceMedia();
    const [scores, setScores] = useState([] as { ID: number, Name: string, ClientBonus: number, EmployeeBonus: number, Score: number }[]);

    /*async function fetchHtml() {
        const html = await (await fetch('./help/help.html')).text();
        setHtml(html);
    }*/

    useEffect(() => {
        //fetchHtml();
        api.getIssueScores().then(s => setScores(s));
        setAsideTop((document.getElementsByTagName('header')[0]).offsetHeight + 2);
        setAppStateHeight((document.getElementsByClassName('app-state')[0] as HTMLElement).offsetHeight);
    }, [api]);

    /*const gotoAnchor = (anchor: string) => {
        window.scroll({
            top: document.getElementById(anchor)?.offsetTop,
            left: 0,
            behavior: 'smooth'
        });
    }*/

    const gotoSection = (event: React.MouseEvent<HTMLElement>) => {
        console.log(document.getElementById(event.currentTarget!.parentElement!.getAttribute('rel')!)?.offsetTop);
        window.scroll({
            top: document.getElementById(event.currentTarget!.parentElement!.getAttribute('rel')!)?.offsetTop,
            left: 0,
            behavior: 'smooth'
        });

        //const button: HTMLButtonElement = event.currentTarget;
    };

    return (
        <Box className='help'>
            {isMobilePortrait ? '' :
                <>
                    <Box style={{ top: asideTop, height: 'calc(100vh - ' + (asideTop + appStateHeight + 20) + 'px)' }} className="help-aside" id="help-aside">
                        <SimpleTreeView>
                            <TreeItem rel="logic" itemId="logic" label="Общая логика" onClick={gotoSection}>
                                <SimpleTreeView>
                                    <TreeItem rel="logic" itemId="description" label="Описание" onClick={gotoSection} />
                                    <TreeItem rel="user-groups" itemId="user-groups" label="Группы пользователей" onClick={gotoSection}>
                                        <SimpleTreeView>
                                            <TreeItem rel="customer-employees" itemId="customer-employees" label="Сотрудники клиентов" onClick={gotoSection} />
                                            <TreeItem rel="employees" itemId="employees" label="Сотрудники Ультимы" onClick={gotoSection} />
                                        </SimpleTreeView>
                                    </TreeItem>
                                    <TreeItem rel="projects" itemId="projects" label="Проекты" onClick={gotoSection} />
                                    <TreeItem rel="issue-states" itemId="issue-states" label="Статусы задачи" onClick={gotoSection} />
                                    <TreeItem rel="active-issue" itemId="active-issue" label="Активная задача" onClick={gotoSection} />
                                    <TreeItem rel="vacation-accrual" itemId="vacation-accrual" label="Начисление отпуска" onClick={gotoSection} />
                                    <TreeItem rel="issue-scores" itemId="issue-scores" label="Оценки за задачи" onClick={gotoSection} />
                                    <TreeItem rel="issue-assessement" itemId="issue-assessement" label="Начисление за задачи" onClick={gotoSection} />
                                </SimpleTreeView>
                            </TreeItem>
                            <TreeItem rel="ui" itemId="ui" label="Интерфейс" onClick={gotoSection}>
                                <SimpleTreeView>
                                    <TreeItem rel="login" itemId="login" label="Вход в трекер" onClick={gotoSection} />
                                    <TreeItem rel="common-page" itemId="common-page" label="Общая компоновка страниц" onClick={gotoSection} />
                                    <TreeItem rel="pages" itemId="pages" label="Страницы" onClick={gotoSection}>
                                        <SimpleTreeView>
                                            <TreeItem rel="dashboard" itemId="dashboard" label="Дашборд" onClick={gotoSection} />
                                            <TreeItem rel="issue" itemId="issue" label="Задача" onClick={gotoSection} />
                                            <TreeItem rel="client-list" itemId="client-list" label="Список клиентов" onClick={gotoSection} />
                                            <TreeItem rel="client" itemId="client" label="Клиент" onClick={gotoSection} />
                                            <TreeItem rel="project" itemId="project" label="Проект" onClick={gotoSection} />
                                            <TreeItem rel="profile" itemId="profile" label="Профиль сотрудника" onClick={gotoSection}>
                                                <SimpleTreeView>
                                                    <TreeItem rel="vacation" itemId="vacation" label="Отпуск" onClick={gotoSection}>
                                                        <SimpleTreeView>
                                                            <TreeItem rel="vacation-request" itemId="vacation-request" label="Запрос отпуска" onClick={gotoSection} />
                                                            <TreeItem rel="vacation-approve" itemId="vacation-approve" label="Подтверждение отпуска" onClick={gotoSection} />
                                                        </SimpleTreeView>
                                                    </TreeItem>
                                                </SimpleTreeView>
                                            </TreeItem>
                                            <TreeItem rel="issue-list" itemId="issue-list" label="Список задач" onClick={gotoSection} />
                                        </SimpleTreeView>
                                    </TreeItem>
                                </SimpleTreeView>
                            </TreeItem>
                        </SimpleTreeView>
                    </Box>
                    <Divider orientation="vertical" flexItem />
                </>
            }
            <Box flex={1} sx={{ p: 2, textAlign:'left' }}>
                <h2 id="logic">Логика работы в новом трекере</h2>
                <p>
                    <h3 id="description">Общее описание</h3>
                    Трекер предназначен для организации взаимодействия между сотрудниками компании Ultima и ее заказчиками. Логика работы трекера определяет права, процессы и алгоритмы расчетов взаиморасчетов являясь приоритетной к любым другим определениям и мнениям.
                    <br />Базовый процесс основан на очереди задач поступающих от авторизованных сотрудников клиентов к нашим сотрудникам обладающих соответствующими навыками (разработка конфигурации, веб или мобильные решения, аналитика и т.п.).
                    <br />Все задачи тарифицируются согласно логике заложенной в данном трекере на основе данных о времени потраченных сотрудником на решение задачи.
                    <br />В каждый момент времени у сотрудника Ultima может быть только одна активная задача. При этом трекер позволяет отложить задачу (если необходимо получить дополнительную информацию от заказчика), а также предоставляет другие статусы задач описанные ниже.
                    <h3 id="user-groups">Группы пользователей</h3>
                    Предусмотрено две группы пользователей, имеющих отличающийся функционал:
                    <ul>
                        <li>
                            <h4 id="customer-employees">Сотрудники клиентов</h4>
                            Могут иметь доступ в трекер с уровнем:
                            <ul>
                                <li>Заявитель</li>
                                <li>Полный доступ</li>
                            </ul>

                            <p>
                                <table className="rights">
                                    <caption style={{textAlign: 'left', paddingBottom: '7px'}}>Имеют следующий права (в зависимости от уровня доступа):</caption>
                                    <tr>
                                        <th>Право</th>
                                        <th>Заявитель</th>
                                        <th>Полный доступ</th>
                                    </tr>
                                    <tr>
                                        <td>Создание задач</td>
                                        <td className="radio checked"></td>
                                        <td className="radio checked"></td>
                                    </tr>
                                    <tr>
                                        <td>Просмотр задач</td>
                                        <td className="radio checked"></td>
                                        <td className="radio checked"></td>
                                    </tr>
                                    <tr>
                                        <td>Редактирование задач *</td>
                                        <td className="radio checked"></td>
                                        <td className="radio checked"></td>
                                    </tr>
                                    <tr>
                                        <td>Изменение статуса задачи **</td>
                                        <td className="radio checked"></td>
                                        <td className="radio checked"></td>
                                    </tr>
                                    <tr>
                                        <td>Оставлять комментарии к задаче</td>
                                        <td className="radio checked"></td>
                                        <td className="radio checked"></td>
                                    </tr>
                                    <tr>
                                        <td>Редактирование своих данных</td>
                                        <td className="radio checked"></td>
                                        <td className="radio checked"></td>
                                    </tr>
                                    <tr>
                                        <td>Редактирование списка сотрудников своей организации</td>
                                        <td className="radio"></td>
                                        <td className="radio checked"></td>
                                    </tr>
                                    <tr>
                                        <td>Редактирование данных своей организации</td>
                                        <td className="radio"></td>
                                        <td className="radio checked"></td>
                                    </tr>
                                </table>
                                <div style={{paddingLeft: '15px', paddingTop: '7px', fontSize: 'smaller'}}>
                                    *&nbsp;&nbsp;до назначения исполнителя
                                    <br />**&nbsp;&nbsp;в соответствии с таблицей ниже
                                </div>
                                <p>
                                    <table className="issue-state-access">
                                        <caption style={{textAlign: 'left', paddingBottom: '7px'}}>Возможности изменения статуса задачи заявителем (автором):</caption>
                                        <tr><td rowSpan={2} colSpan={2}>&nbsp;</td><td colSpan={8} style={{textAlign: 'center',}}>В статус</td></tr>
                                        <tr>
                                            <td className="to-state">Создана</td>
                                            <td className="to-state">Очередь</td>
                                            <td className="to-state">Назначена</td>
                                            <td className="to-state">В работе</td>
                                            <td className="to-state">Тестирование</td>
                                            <td className="to-state">Пауза</td>
                                            <td className="to-state">Доступна</td>
                                            <td className="to-state">Завершена</td>
                                        </tr>
                                        <tr>
                                            <td style={{maxWidth: '30px',}} rowSpan={8}><div style={{whiteSpace: 'nowrap', marginTop: '50px',overflow: 'visible', transform: 'rotate(-90.0deg)'}}>Из статуса</div></td>
                                            <td className="tal">Создана</td>
                                            <td style={{background: 'silver'}}></td>
                                            <td className="radio checked"></td>
                                            <td className="radio checked" style={{paddingLeft: '35px',}}>*</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td className="tal">Очередь</td>
                                            <td></td>
                                            <td style={{background: 'silver'}}></td>
                                            <td className="radio checked" style={{paddingLeft: '35px',}}>*</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td className="tal">Назначена</td>
                                            <td></td>
                                            <td></td>
                                            <td style={{background: 'silver'}}></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td className="tal">В работе</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td style={{background: 'silver'}}></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td className="tal">Тестирование</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td style={{background: 'silver'}}></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td className="tal">Пауза</td>
                                            <td></td>
                                            <td></td>
                                            <td className="radio checked"></td>
                                            <td></td>
                                            <td></td>
                                            <td style={{background: 'silver'}}></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td className="tal">Доступна</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td style={{background: 'silver'}}></td>
                                            <td className="radio checked"></td>
                                        </tr>
                                        <tr>
                                            <td className="tal">Завершена</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td style={{background: 'silver'}}></td>
                                        </tr>
                                    </table>
                                    <div style={{paddingLeft: '15px', paddingTop: '7px', fontSize: 'smaller'}}>
                                        *&nbsp;&nbsp;в проектах без автораспределения
                                    </div>
                                </p>
                            </p>
                        </li>
                        <li>
                            <h4 id="employees">Сотрудники Ультимы</h4>
                            <p>
                                Могут иметь доступ в трекер с уровнем:
                                <ul>
                                    <li>Новичок</li>
                                    <li>Разработчик</li>
                                    <li>Полный доступ</li>
                                </ul>
                            </p>
                            <table className="rights">
                                <caption style={{textAlign: 'left', paddingBottom: '7px'}}>Имеют следующий права:</caption>
                                <tr>
                                    <th>Право</th>
                                    <th>Разработчик</th>
                                    <th>Полный доступ</th>
                                </tr>
                                <tr>
                                    <td>Создание задач</td>
                                    <td className="radio checked"></td>
                                    <td className="radio checked"></td>
                                </tr>
                                <tr>
                                    <td>Просмотр задач</td>
                                    <td className="radio checked"></td>
                                    <td className="radio checked"></td>
                                </tr>
                                <tr>
                                    <td>Редактирование задач *</td>
                                    <td className="radio checked"></td>
                                    <td className="radio checked"></td>
                                </tr>
                                <tr>
                                    <td>Изменение статуса задачи **</td>
                                    <td className="radio checked"></td>
                                    <td className="radio checked"></td>
                                </tr>
                                <tr>
                                    <td className="tal">Редактирование своих данных</td>
                                    <td className="radio checked"></td>
                                    <td className="radio checked"></td>
                                </tr>
                                <tr>
                                    <td>Оставлять комментарии к задаче</td>
                                    <td className="radio checked"></td>
                                    <td className="radio checked"></td>
                                </tr>
                            </table>
                            <div style={{paddingLeft: '15px',paddingTop: '10px',}}>
                                * до назначения исполнителя
                                <br />** в соответствии с таблицей ниже
                            </div>
                            <br />

                            <table className="issue-state-access">
                                <caption style={{textAlign: 'left', paddingBottom: '7px'}}>Возможности изменения статуса задачи исполнителем:</caption>
                                <tr><td rowSpan={2} colSpan={2}>&nbsp;</td><td colSpan={8} style={{textAlign: 'center',}}>В статус</td></tr>
                                <tr>
                                    <td className="to-state">Создана</td>
                                    <td className="to-state">Очередь</td>
                                    <td className="to-state">Назначена</td>
                                    <td className="to-state">В работе</td>
                                    <td className="to-state">Тестирование</td>
                                    <td className="to-state">Пауза</td>
                                    <td className="to-state">Доступна</td>
                                    <td className="to-state">Завершена</td>
                                </tr>
                                <tr>
                                    <td style={{ maxWidth: '40px', }} rowSpan={8}><div style={{ whiteSpace: 'nowrap', marginTop: '60px', overflow: 'visible', transform: 'rotate(-90.0deg)' }}>Из статуса</div></td>
                                    <td className="tal">Создана</td>
                                    <td style={{background: 'silver'}}></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="tal">Очередь</td>
                                    <td></td>
                                    <td style={{background: 'silver'}}></td>
                                    <td className="radio checked" style={{paddingLeft: '35px',}}>*</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr >
                                <tr>
                                    <td className="tal">Назначена</td>
                                    <td></td>
                                    <td className="radio checked" style={{paddingLeft: '45px',}}>**</td>
                                    <td style={{background: 'silver'}}></td>
                                    <td className="radio checked"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr >
                                <tr>
                                    <td className="tal">В работе</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td style={{background: 'silver'}}></td>
                                    <td className="radio checked"></td>
                                    <td className="radio checked"></td>
                                    <td className="radio checked"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="tal">Тестирование</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="radio checked"></td>
                                    <td style={{background: 'silver'}}></td>
                                    <td className="radio checked"></td>
                                    <td className="radio checked"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="tal">Пауза</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="radio checked"></td>
                                    <td></td>
                                    <td style={{background: 'silver'}}></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="tal">Доступна</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td style={{background: 'silver'}}></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="tal">Завершена</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td style={{background: 'silver'}}></td>
                                </tr>
                            </table>
                            <div style={{ paddingLeft: '15px', paddingTop: '7px', fontSize: 'smaller' }}>
                                *&nbsp;&nbsp;взять себе в проектах без автораспределения
                                <br />**&nbsp;&nbsp;отказаться при условии отсутствия записанных часов
                            </div>
                        </li>
                    </ul> 
                </p>

                <p>
                    <h3 id="projects">Проекты</h3>
                    По механизму распределения задач между исполнителями проекты бывают двух типов:
                    <ul>
                        <li>Автоматическое распределение задач:
                            <br />На выбор исполнителя влияет:
                            <ul>
                                <li>Является ли сотрудник "предпочтительным исполнителем" в данной задаче</li>
                                <li>Наличия у сотрудника активной задачи в данный момент</li>
                                <li>Наличия у сотрудника требующихся для выполнения задачи навыков</li>
                                <li>При прочих равных выбор будет произведен случайным образом</li>
                            </ul>
                        </li>
                        <li>Ручное распределение задач
                            <br />В проектах с ручным выбором исполнителей заявитель по задаче может выбрать сотрудника из списка.
                            <br />Список возможных исполнителей формируется путем привязки их к проекту.
                            <br />Также в проектах с ручным распределением задач исполнитель может самостоятельно взять себе задачу из очереди.
                        </li>
                    </ul>
                </p>

                <p>
                    <h3 id="issue-states">Статусы задачи</h3>
                    Задача может находится в одном из следующих статусов:
                    <dl>
                        <dt>Создана (беклог)</dt>
                        <dd>Задача находится в этом статусе после создания и последующего изменения заголовка и/или описания.
                            <br />Созданные по кнопке "создать" задачи, в которых не был изменен заголовок и/или описание, не будут отображаться нигде</dd>
                        <dt>Очередь</dt>
                        <dd>
                            После создания задачи и окончательной редакции ее атрибутов (заголовок, описание, приоритет, клиент/проект, предпочтительные исполнители), можно разместить задачу в очереди.
                            <br />В проектах с включенным автораспределением, задачи, размещенные в очереди, будут назначены подходящему исполнителю (исходя из требуемых навыков, списка предпочтительных исполнителей, занятости исполнителей и т.д.)
                            <br />В проектах с ручным распределением задач, можно разместить задачу в очереди без указания исполнителя, чтобы желающий мог сам "взять ее себе", или сразу назначить на конкретного исполнителя.
                            <br />"Предпочтительные исполнители" в проектах с ручным распределением задач не оказывают влияния на процесс назначения задачи.
                        </dd>
                        <dt>Назначена</dt>
                        <dd>
                            В этом статусе находятся задачи, назначенные на конкретного исполнителя.
                            <br />Исполнитель может отказаться от выполнения задачи (если он еще не успел записать себе часы по этой задаче) либо принять ее в работу.
                        </dd>
                        <dt>В работе</dt>
                        <dd>
                            В этом статусе находятся назначенные задачи после принятия их в работу назначенным исполнителем.
                            <br />При приеме задачи в работу необходимо указать предполагаемое кол-во часов, которые будут затрачены на ее выполнение.
                            <br />Исходя из внесенного предполагаемого кол-ва часов, автоматически будет рассчитан предполагаемый срок выполнения задачи (исходя из кол-ва часов и графика рабочих дней).
                            <br />Запланированный срок исполнения может быть изменен исполнителем (и только им) с внесением комментарий о причинах такого изменения.
                        </dd>
                        <dt>Тестирование</dt>
                        <dd>
                            После того, как исполнитель считает, что основные работы по задаче выполнены, он может приступить к ее тестированию.
                            <br />Статус "тестирование" носит информационный (для клиента) характер, в остальном он ничем не отличается от статуса "в работе".
                        </dd>
                        <dt>Пауза (нужны комментарии)</dt>
                        <dd>
                            Исполнитель может поставить задачу н паузу, если ему необходима какая-то дополнительная информация, с указанием комментария, какая именно.
                            <br />Вернуть задачу в работу может либо автор задачи, предоставив необходимые комментарии, либо сам исполнитель, если необходимость в них отпала.
                            <br />При возврате, если это делает не исполнитель (а автор), задача будет возвращена в статусу "назначена".
                        </dd>
                        <dt>Пауза (отложена ради критической задачи)</dt>
                        <dd>
                            При назначении исполнителю критической задачи в случае, если у него уже есть задача в работе (или тестировании), последняя будет поставлена на паузу со статусом "отложена ради выполнения критической задачи".
                            <br />После выполнения критической, приостановленная таким образом задача будет автоматически возобновлена (точнее, переведена в статус "назначена")
                        </dd>
                        <dt>Доступна для клиента</dt>
                        <dd>
                            После того, как исполнитель считает задачу выполненной, он переводит ее в статус "доступна для клиента".
                            <br />После этого у клиента есть определенный срок для того, чтобы завершить задачу.
                            <br />При завершении задачи клиент может поставить исполнителю оценку за выполненную работу и/или оставить комментарий.
                            <br />Задачи, не завершенные заявителем в оговоренный срок, будут завершены автоматически (с оценкой 8/10).
                        </dd>
                        <dt>Завершена</dt>
                        <dd>
                            Это финальный статус задачи, в который она переходит при завершении её клиентом или автоматически по истечению предоставленного не это заявителю время.
                            <br />Никакие действия с задачей невозможны после ее завершения.
                        </dd>
                    </dl>
                </p>

                <p>
                    <h3 id="active-issue">Активная задача</h3>
                    "Активная задача" - это задача, находящаяся у исполнителя в работе или в тестировании.
                    <br />В каждый момент времени активная задача у конкретного исполнителя может быть <b>только одна</b>.
                </p>

                <p>
                    <h3 id="vacation-accrual">Начисление отпуска</h3>
                    За отработанное время сотруднику начисляются часы отпуска из расчета  "отработанные часы * (28 / 247)" (28 - кол-во дней отпуска в году, 247 - кол-во рабочих дней в (2025-м) году.
                    <br />Начисление отпускных часов происходит в момент записи активности (часов) по любой задаче.
                    <br />Кол-во накопленных дней отпуска равно округленному (вниз) кол-ву начисленных отпукных часов / 7 (7 часов в рабочем дне).
                    <br />При запросе отпуска (вне зависимости от его подтверждения) с баланса накопленных отпускных часов списывается кол-во часов из расчета "запрошено кол-во дней отпуска * 7" (7 часов в рабочем дне).
                    <br />При подтверждении отпуска сотруднику начисляются деньги из расчета "средняя фактическая стоимости 1-го часа сотрудника за последние три месяца * 7 * кол-во запрошенных дней".
                </p>

                <p>
                    <h3 id="issue-scores">Оценка задач</h3>
                    Задачи оцениваются заявителем (автором задачи) по шкале от 1 до 10.
                    <br />Если заявитель с течение оговоренного срока не выставил оценку, задача будет закрыта автоматически с оценкой "8"
                </p>

                <p>
                    <h3 id="issue-assessement">Начисление за задачи</h3>
                    Начисление за задачу происходит из расчета:
                    <ul>
                        <li>Для сотрудника: Часы * ставка сотрудника за час * коэффициенты</li>
                        <li>Для клиента: Часы * стоимость часа * коэффициенты</li>
                    </ul>
                    <br />Используемые коэффициенты:
                    <dl>
                        <dt>Коэффицент "предпочтительного сотрудника"</dt>
                        <dd>Устанавливается самим сотрудникам (в процентах) в своем профиле.
                        <br />Применяется, если автор задачи отметил сотрудника, как предпочтительного для данной задачи</dd>
                        <dt>Коэффицент за оценку</dt>
                        <dd>Зависит от оценки, выставленной клиентом:
                            <table>
                                <tr><th>Оценка</th><th>Исполнитель</th><th>Заявитель</th></tr>
                                {scores.map(x => <tr><td style={{ border: '1px solid #dddddd', padding: '0px 10px' }}>{`${x.Name}`}</td><td style={{ border: '1px solid #dddddd', padding: '0px 10px', textAlign: 'right' }}>{x.ID == 1 ? '-' : `${x.EmployeeBonus > 0 ? '+' + x.EmployeeBonus : x.EmployeeBonus}%`}</td><td style={{ border: '1px solid #dddddd', padding: '0px 10px', textAlign: 'right' }}>{x.ID == 1 ? '-' : `${x.ClientBonus > 0 ? '+' + x.ClientBonus : x.ClientBonus}%`}</td></tr>)}
                            </table>
                        </dd>
                    </dl>
                </p>

                <h2 id="ui">Интерфейс</h2>
                <h3 id="login">Вход в трекер</h3>
                <img src="./help/login.png" alt="Страница входа" width="100%" />
                <p>Для входа в трекер необходимо ввести Ваш логин и пароль.</p>
                <p>Можно воспользоваться ссылкой "восстановить пароль". Для восстановления пользователь должен быть зарегистрирован в трекере (иметь логин) и иметь заполненный в профиле адрес электронной почты</p>

                <h3 id="common-page">Общая компоновка страниц трекера</h3>
                <p>
                    В верхней части страницы располагается общий для всех страниц заголовок содержащий:
                    <img src="./help/header.png" alt="Заголовок" width="100%" />
                    <ul>
                        <li>Блок "активная задача" (только для сотрудника Ультимы):
                            <ul>
                                <li>Название активной задачи</li>
                                <li>Последняя или текущая активность (таймер рабочего времени)</li>
                                <li>Кнопка начала/остановки таймера рабочего времени</li>
                            </ul>
                            Если активной задачи нет, будет отображаться надпись "нет активной задачи"
                            Данный блок не является автообновляемым, и не изменится, если, например, робот назначит Вам задачу. Для обновления необходимо обновить страницу.
                        </li>
                        <li>Логотип - ссылка на дашборд авторизованного пользователя</li>
                        <li>Меню:
                            <ul>
                                <li>Создать задачу. Позволяет выбрать приоритет создаваемой задачи и является ли задача "ошибкой"</li>
                                <li>Задачи. Список всех задач, доступных авторизованному пользователю</li>
                                <li>Клиенты. Список всех клиентов (только для сотрудника Ультимы)</li>
                            </ul>
                        </li>
                        <li>Окно для быстрого перехода к задаче по ее номеру</li>
                        <li>Аватар (или инициалы, если аватар не установлен) авторизованного пользователя, предлагающий контекстное меню:
                            <ul>
                                <li>Мой профиль</li>
                                <li>Моя организация (только для сотрудника клиента)</li>
                                <li>Выйти</li>
                            </ul>
                        </li>
                    </ul>
                </p>

                <h3 id="pages">Страницы</h3>
                <h4 id="dashboard">Дашборд</h4>
                <figure>
                    <figcaption>Дашборд сотрудника</figcaption>
                    <img src="./help/dashboard-employee.png" alt="Дашборд сотрудника" />
                </figure>
                <figure>
                    <figcaption>Дашборд сотрудника клиента</figcaption>
                    <img src="./help/dashboard-customer-employee.png" alt="Дашборд клиента" />
                </figure>
                <p>Домашней страницей трекера (т.е. страницей, открывающейся, если в адресной строке задан путь <a href="/">https://tracker.ultima.ru/</a>) является дашборд авторизованного в трекере сотрудника</p>
                <p>Также на страницу своего дашборда можно попасть, кликнув на логотип dia$par в заголовке трекера</p>
                <div style={{marginLeft: '30px',}}>
                    <p>В левой части дашборда находится некоторая статистика по пользователю:</p>
                    <div style={{marginLeft: '30px',}}>
                        Для сотрудника Ультимы:
                        <ul>
                            <li>Активная задача, если она есть</li>
                            <li>Статистика записанных часов (за сегодня, за вчера, с начала месяца, за последние 30 дней)</li>
                            <li>Текущий денежный баланс. Клик на этот блок откроет детализацию баланса (транзакции) за текущий месяц</li>
                            <li>Кол-во накопленных на сегодня дней отпуска</li>
                        </ul>
                    </div>
                    <div style={{ marginLeft: '30px',}}>
                        Для сотрудника клиента:
                        <ul>
                            <li>Длину <b>общей</b> (т.е. по всем клиентам) очереди задач (только в состоянии "в очереди", т.е. не считая активных задач или задач "на паузе")</li>
                            <li>Статистика часов, записанных по задачам (за сегодня, за текущий месяц), где сотрудник является автором, с детализацией по приоритетам</li>
                            <li>Кол-во задач сотрудника, где сотрудник является автором, с детализацией по состояниям</li>
                        </ul>
                    </div>
                </div>
                <div style={{ marginLeft: '30px',}}>
                    <p>В правой части дашборда находится список задач, имеющих отношение к пользователю:</p>
                    <div style={{marginLeft: '30px',}}>
                        Только для сотрудника Ультимы:
                        <ul>
                            <li>Список ошибок за месяц</li>
                            <li>Список задач, назначенных пользователю</li>
                        </ul>
                        Дальше идет три блока задач, где сотрудник является автором:
                        <ul>
                            <li>Выполненные (но еще не принятые автором) задачи</li>
                            <li>Задачи, требующие комментариев</li>
                            <li>Полный список задач, кроме выполненных</li>
                        </ul>
                        Для сотрудника Ультимы два из этих трех блоков - "готовые задачи" и "задачи, требующие комментариев" - отображаются только если таковые есть.
                    </div>
                </div>

                <h4 id="issue">Страница задачи</h4>
                <figure>
                    <img src="./help/issue.png" alt="Страница задачи" />
                </figure>
                <p>
                    На странице задачи в основной части расположены:
                    <ul>
                        <li>Заголовок задачи</li>
                        <li>Описание (разворачиваемое) задачи</li>
                        <li>Список активностей по задаче:
                            <ul>
                                <li>Изменение заголовка и/или описания задачи</li>
                                <li>Изменение статуса задачи</li>
                                <li>Комментарии к задаче</li>
                                <li>Записанные часы</li>
                                <li>Изменение результата</li>
                                <li>и т.д.</li>
                            </ul>
                            Данный список обновляется при совершении какого-то действия с задачей, но не имеет автообновления. Для того, чтобы принудительно обновить список активностей, можно нажать "обновить страницу" (F5)
                        </li>
                        <li>Кнопка "редактировать", которая дает возможность автору отредактировать заголовок и текст задачи, до того момента, как задача будет назначена исполнителю</li>
                    </ul>
                    В правой части расположены блоки управления задачей:
                    <ul>
                        <li>Основной блок, в котором можно:
                            <ul>
                                <li>Сменить приоритет задачи. Смена приоритета возможна в статусах "создана" или "очередь" и осуществляется кликом по названию приоритета</li>
                                <li>Сменить статус задачи (например "в работе" → "тестирование", или "назначена" → "в работе"). Смена статуса производится с помощью выпадающего меню, открывающегося по клику на "три точки" рядом с текущим статусом задачи. Для смены статуса текущая активность (таймер) должна быть остановлена.</li>
                                <li>Изменить срок по задаче (дедлайна) (доступно только исполнителю)</li>
                                <li>Изменить клиента/проект/направление по задаче. Изменение любого из этих атрибутов происходит в одном и том же окне, т.к. они взаимосвязаны. Также связанным является список предпочтительных исполнителей, который будет доступен к изменению в том же диалоге.</li>
                                <li>Для проекта, в котором отключено автораспределение задач, можно изменить исполнителя</li>
                            </ul>
                        </li>
                        <li>Блок "трекер" со статистикой часов по задаче: запланировано, записано на данный момент, последняя запись часов и кнопкой начала/окончания активности (таймер часов)</li>
                        <li>Блок "приложения" со всеми приложениями (файлами) к задаче</li>
                    </ul>
                </p>

                <h4 id="client-list">Страница списка клиентов (только для сотрудника Ультимы)</h4>
                <figure>
                    <img src="./help/client-list.png" alt="Список клиентов" />
                </figure>
                <p>
                    Страница "клиенты" содержит список клиентов в виде таблицы
                </p>

                <h4 id="client">Страница клиента</h4>
                <figure>
                    <img src="./help/client.png" alt="Страница клиента" />
                </figure>
                <p>
                    Страница "клиент" содержит информацию о клиенте.
                </p>
                <p>
                    В левой части отображаются контактные данные клиента и ответственный сотрудник (это может быть как наш сотрудник, так и сотрудник клиента)
                </p>
                <p>
                    В правой части отображаются три разворачиваемых блока:
                    <ul>
                        <li>Сотрудники клиента
                            <div>Содержит список сотрудников клиента, с возможностью редактирования. Редактирование осуществляется сотрудником данного клиента с полным доступом</div>
                        </li>
                        <li>Нередактируемый список проектов клиента</li>
                        <li>Нередактируемые реквизиты клиента</li>
                    </ul>
                </p>

                <h4 id="project">Страница проекта</h4>
                <figure>
                    <img src="./help/project.png" alt="Страница проекта" />
                </figure>
                <p>
                    Отдельной страницы со списком проектов нет.
                </p>
                <p>
                    На страницу проекта можно попасть по ссылкам из разных мест (например, со страницы клиента, блок "проекты").
                </p>
                <p>
                    На странице проекта содержится информация:
                    <ul>
                        <li>Клиент</li>
                        <li>Ответственный сотрудник (куратор)</li>
                        <li>Признак нахождения проекта в архиве</li>
                        <li>Признак автораспределения задач в проекте</li>
                        <li>Признак начисления бонуса предпочтительному исполнителю.</li>
                        <li>Правила, действующие в данном проекте. Редактируется сотрудником Ультимы с полным доступом к трекеру. (аналог TechData в старом трекере)</li>
                    </ul>
                </p>

                <h4 id="profile">Страница профиля сотрудника</h4>
                <figure>
                    <img src="./help/profile.png" alt="Профиль сотрудника" />
                </figure>
                <p>
                    На странице сотрудника в левой части расположены:
                    <ul>
                        <li>Персональные данные</li>
                        <li>Контактные данные</li>
                        <li>Данные сотрудника, как работника: должность, прием/увольнение, руководитель, данные для расчета заработка (для сотрудника Ультимы) и т.п.</li>
                        <li>Пользователь трекера: логин и уровень доступа</li>
                        <li>Платежные реквизиты (только для сотрудника Ультимы)</li>
                    </ul>
                    Кнопка "...", расположенная с правом верхнем углу блока с аватаркой и именем сотрудника, позволяет изменить свои данные, отображенные в этой части.
                </p>
                <p>
                    В основной части (только для сотрудника Ультимы) расположен блок с его расписанием на выбранный период и кнопками "изменить шаблон" и "запрос отпуска".
                    <br />
                    Сотрудник может:
                    <ul>
                        <li>Изменить свои рабочие часы, начиная с завтрашнего дня:
                            <ul>
                                <li>Пометив час рабочим/нерабочим кликом мыши</li>
                                <li>Нажав кнопку "Заполнить день по шаблону" в строке с интересующей датой</li>
                                <li>Нажав кнопку "Заполнить неделю по шаблону" в группе строк недели</li>
                            </ul>
                        </li>
                        <li>Изменить шаблон своей рабочей недели (кнопка "изменить шаблон")
                            <figure>
                                <img src="./help/template-change.png" alt="Изменение шаблона расписания" />
                            </figure>
                        </li>
                        <li>Запросить отпуск</li>
                    </ul>
                </p>
                <p>
                    <h5 id="vacation">Отпуск (только для сотрудника Ультимы)</h5>
                    <h6 id="vacation-request">Запрос отпуска</h6>
                    <figure>
                        <img src="./help/vacation-request.png" alt="Запрос отпуска" />
                    </figure>
                    Для запроса отпуска необходимо нажать соответствующую кнопку над расписание и отметить интересующие дня.
                    <br />Во всплывающем окне будет выведена информация о количестве накопленных на текущую дату дней отпуска и запрашиваемом кол-ве дней.
                    <br />* ранее запрошенные дня вычитаются из накопленных, вне зависимости от того, подтверждены они или нет.
                    <br />При запросе отпуска руководителю сотрудника на электронную почту будет направлено соответствующее письмо.
                    <h6 id="vacation-approve">Подтверждение отпуска</h6>
                    <br />При запросе сотрудником отпуска на странице его профиля, при просмотре его руководителем, появляется блок "запрос отпуска", содержащий информацию о всех неподтвержденных запросах, остатке отпуска (уже с учетом запрашиваемых) и кнопка "подтвердить" на каждый такой запрос.
                    <figure>
                        <img src="./help/vacation-request-cheef-view.png" alt="Запрос отпуска со стороны руководителя" />
                    </figure>
                </p>

                <h4 id="issue-list">Страница списка задач</h4>
                <figure>
                    <img src="./help/issue-list.png" alt="Список задач" />
                </figure>
                <p>
                    На странице списка задач расположены:
                    <ul>
                        <li>Панель фильтрации:
                            <ul>
                                <li>Кнопка отображения расширенного фильтра. Расширенный фильтр позволяет отфильтровать список задач по любому полю/набору полей задачи.</li>
                                <li>Переключатель "Мои задачи". Во включенном состоянии фильтрует список задач по значению полей "автор" или "исполнитель", соответствующему авторизованному пользователю.</li>
                                <li>Кнопки фильтрации задач по статусам. Кнопка "все" снимает фильтрацию списка по статусу задачи, остальные кнопки фильтруют список по соответствующим статусам (в режиме "или")</li>
                            </ul>
                        </li>
                        <li>Строка поиска задачи по тексту. Поиск осуществляется по полям "Заголовок", "Описание", а также по тексту комментариев к задаче и тексту комментариев к записанным часам</li>
                        <li>Список задач в виде таблицы. Вывод осуществляется постранично, размер страницы - 100 строк. Доступна сортировка (в обоих направлениях) по любому полю, путем нажатия на заголовок таблицы</li>
                    </ul>
                    <figure>
                        <figcaption>Отфильтрованный список задач</figcaption>
                        <img src="./help/issue-list-filtered.png" alt="Отфильтрованный список задач" />
                    </figure>
                </p>
            </Box>
        </Box>
    );
};